import { Text } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import React from 'react';
export const buildTranslations = _ref => {
  let {
    t,
    filledCount,
    totalCount,
    pageName
  } = _ref;
  return {
    aiWarningText: t('accessibility-wizard.alt-text.overview-section.progress-bar.ai-accuracy-warning'),
    applyLabel: t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.apply.tooltip.apply-button'),
    cancelLabel: t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.cancel'),
    closeButtonAriaLabel: t('accessibility-wizard.alt-text.closeAriaLabel'),
    description: t('accessibility-wizard.alt-text.overview-section.progress-bar.description'),
    disabledTooltips: {
      'all-apng': t('accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.all-apng'),
      'all-avif': t('accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.all-avif'),
      'all-gif': t('accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.all-gif'),
      'all-mix-unsupported': t('accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.all-mix-unsupported'),
      'all-svg': t('accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.all-svg'),
      'no-missing-alt-text': t('accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.no-missing-alt-text')
    },
    formatPaginationRange: (start, end, total) => t('accessibility-wizard.alt-text.elements-list.element-indexes', {
      endIndex: end,
      startIndex: start,
      totalAmount: total
    }),
    generateAiLabel: t('accessibility-wizard.alt-text.generate-with-ai-button.cta'),
    headerTitle: t('accessibility-wizard.alt-text.header.title', {
      pageName
    }),
    helperTip: {
      content: /*#__PURE__*/React.createElement(Trans, {
        components: {
          bold: /*#__PURE__*/React.createElement(Text, {
            size: "tiny",
            weight: "bold",
            secondary: true
          })
        },
        i18nKey: "accessibility-wizard.rules-list.alt-image.tip.1"
      })
    },
    imageItem: {
      decorativeDisabledTooltip: t('accessibility-wizard.rules-list.alt-image.checkbox.linked.tooltip'),
      decorativeLabel: t('accessibility-wizard.rules-list.alt-image.checkbox.label'),
      decorativeText: t('accessibility-wizard.rules-list.alt-image.decorative-image-title-value'),
      editAriaLabel: t('accessibility-wizard.common.edit.aria-label'),
      editTooltip: t('accessibility-wizard.common.edit'),
      enlargeButtonTooltip: t('accessibility-wizard.alt-text.enlarge-image-icon-button.tooltip'),
      failedToGenerateWarning: t('accessibility-wizard.rules-list.alt-image.input-section.warning.failed-to-generate'),
      generateLabel: t('accessibility-wizard.alt-text.generate-with-ai-button.cta'),
      generatingLabel: t('accessibility-wizard.alt-text.generate-with-ai-button.generating-single'),
      imageExtensionErrorMessage: t('accessibility-wizard.rules-list.alt-image.text-in-image.input-section.warning.has-image-extension'),
      inputLabel: t('accessibility-wizard.rules-list.alt-image.content.input.label'),
      inputPlaceholder: t('accessibility-wizard.rules-list.alt-image.content.input.placeholder'),
      minimizeButtonTooltip: t('accessibility-wizard.alt-text.minimize-image-icon-button.tooltip'),
      placeholderText: t('accessibility-wizard.rules-list.alt-image.default-title-value.drill-in')
    },
    listHeaderTitle: t('accessibility-wizard.rules-list.alt-image.list.failed-elements-number.heading'),
    progressText: t('accessibility-wizard.alt-text.overview-section.progress-bar.filled', {
      filledAmount: filledCount,
      totalAmount: totalCount
    }),
    stopGeneratingModal: {
      content: t('accessibility-wizard.alt-text.stop-generating-modal.content'),
      continueButtonText: t('accessibility-wizard.alt-text.stop-generating-modal.primary-button'),
      stopButtonText: t('accessibility-wizard.alt-text.stop-generating-modal.secondary-button'),
      title: t('accessibility-wizard.alt-text.stop-generating-modal.title')
    },
    summary: {
      failedText: count => t('accessibility-wizard.alt-text.summary.failed', {
        failedCount: count
      }),
      generatedText: count => t('accessibility-wizard.alt-text.summary.generated', {
        generatedCount: count
      }),
      getUnsupportedTooltip: keySuffix => keySuffix ? t(`accessibility-wizard.alt-text.generate-with-ai-button.tooltip.description.${keySuffix}`) : '',
      sortFirstLabel: t('accessibility-wizard.alt-text.summary.unsupported.sort'),
      tryAgainLabel: t('accessibility-wizard.alt-text.summary.failed.try-again'),
      unsupportedText: count => t('accessibility-wizard.alt-text.summary.unsupported', {
        unsupportedCount: count
      })
    }
  };
};
//# sourceMappingURL=translations.js.map